/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PaymentTypesEnum {
  Water = 1,
  Electric = 2,
  Gas = 3,
  Sewer = 4,
  Phone = 5,
  Internet = 6,
  Cable = 7,
  LandTax = 8,
  CountyTax = 9,
  TownshipMunicipalTax = 10,
  StateTax = 11,
  FederalTax = 12,
  Payroll = 13,
  LiabilityInsurance = 14,
  WorkersCompensation = 15,
  RenterInsurance = 16,
  PropertyInsurance = 17,
  BankFee = 18,
  Mortgage = 19,
  LegalFee = 21,
  ViolationCharge = 22,
  HoaFee = 23,
  SecurityDeposit = 24,
  Rent = 25,
  LateFee = 26,
  Invoice = 27,
  Labor = 28,
  ServiceRequest = 29,
  SecurityDepositReturn = 30,
  Refund = 31,
  OtherSettlement = 32,
  Commission = 33,
  Other = 34,
  HardwareStore = 35,
  ApplianceStore = 36,
  FurnitureStore = 37,
  OtherStore = 38,
  ElectricAndGas = 39,
  PlatformSubscription = 40,
}
